import { Component, inject, OnInit, signal, computed, effect, ChangeDetectionStrategy } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { UserStreak } from '../../dashboard.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-user-streak',
  imports: [ MatProgressSpinnerModule, FontAwesomeModule ],
  templateUrl: './user-streak.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-streak.component.scss',
})
export class UserStreakComponent implements OnInit {

  private readonly api = inject(DashboardService);
  private readonly snackbar = inject(SnackbarService);
  
  public readonly streak = signal<UserStreak | undefined>(undefined)
  public isLoading = signal(false);
  public animationPlayed = signal(false);
  
  public animatedChars = computed(() => {
    const msg = 'Weekly share streak';
    return msg.split('').map((char, index) => ({ char, index }));
  });
  
  constructor() {
    effect(() => {
      if (this.streak() && !this.animationPlayed()) {
        this.animationPlayed.set(true);
      }
    });
  }

  ngOnInit(): void {
    this.loadStreaks();
  }

  async loadStreaks() {
    try {
      this.isLoading.set(true);
      const result = await this.api.getStreaks();
      this.streak.set(result);
    } catch (error) {
      console.debug(error);
      this.snackbar.showErrorMessageSnackBar("There was a problem loading your streak data");
    } finally {
      this.isLoading.set(false);
    }
  }


}
